/** Shared by the team create, team detail and add-on assign-teams toggles. */
export const DENY_PORTAINER_ACCESS_TOOLTIP =
  "Members of this team can only use the add-ons they've been granted. They won't see the Portainer management UI, and will land on an add-on when they log in.";
